import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_GroupingMode_Switch_Mutation = graphql(`
  mutation MissionServicesInfoForm_GroupingMode_Switch(
    $groupingMode: GroupingModeEnum!
    $label: String
    $serviceUserId: Id!
    $versionData: VersionDataInput
  ) {
    switchMissionGroupingMode(
      groupingMode: $groupingMode
      label: $label
      serviceUserId: $serviceUserId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useSwitchMissionGroupingModeMutation = () =>
  useGraphQLMutation(MissionServicesInfoForm_GroupingMode_Switch_Mutation);
